import { useFormDataContext } from 'modules/taboola-common-frontend-modules/formData';
import { useFetchedCampaignGroup } from '../../CampaignGroupField/hooks/useFetchedCampaignGroup';

export const useCampaignBudgetRestrictions = () => {
    const {
        data: { campaignGroupInfo },
    } = useFormDataContext();
    const campaignGroup = useFetchedCampaignGroup(campaignGroupInfo?.campaignGroupId);

    return {
        campaignGroup,
        campaignGroupBudget: campaignGroup?.budget,
    };
};
